export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <div className="text-center mb-6">
            <span className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 mx-auto mb-4">
              <i className="ri-movie-2-line text-2xl text-primary-600"></i>
            </span>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
              关于悟空影视
            </h2>
          </div>

          <div className="space-y-4 text-sm text-foreground-500 leading-relaxed">
            <p>
              <strong className="text-foreground-900">悟空影视</strong>成立于 2024 年，是国内领先的免费高清影视在线观看平台。我们汇聚海量优质影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，致力于为数千万影迷提供<strong className="text-foreground-900">无需注册、即点即播、流畅不缓冲</strong>的极致观影体验。
            </p>
            <p>
              平台依托自主开发的智能分发系统和全球 CDN 加速网络，确保每部影片都能以最优画质和最快速度送达用户屏幕。无论是手机、平板还是电脑，打开浏览器即可畅享 1080P 高清画质，真正做到<strong className="text-foreground-900">零门槛、零等待、零成本</strong>。
            </p>
            <p>
              我们的内容团队每日实时追踪全球最新影视动态，确保热门剧集播出后第一时间上线更新。从国产热播剧到好莱坞大片，从经典老片到小众佳作，悟空影视始终以<strong className="text-foreground-900">最全、最新、最快</strong>的内容覆盖满足每一位影迷的观看需求。
            </p>
            <p>
              我们将继续坚持免费服务的初心，不断优化产品体验，让更多人能够轻松享受到高品质的影视娱乐内容。悟空影视 —— <strong className="text-foreground-900">让好片触手可及</strong>。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/60">
            {[
              { num: '5000万+', label: '月活用户' },
              { num: '10万+', label: '影视资源' },
              { num: '200+', label: '每日更新' },
              { num: '99.9%', label: '服务可用率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-lg md:text-xl font-bold font-heading text-primary-600">{stat.num}</div>
                <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}